import {useField} from 'formik';
import {useCallback} from 'react';

import {AssignmentSelectors, AssignmentSelectorsProps} from './AssignmentSelectors';

type Props = {
    name: string;
    groupIdProp?: string;
    subgroupIdProp?: string;
} & Partial<AssignmentSelectorsProps>;

export type AssignmentSelectorsFormikProps = Props;

export const AssignmentSelectorsFormik: React.FC<Props> = ({
    name, onChange, groupIdProp = 'groupId', subgroupIdProp = 'subgroupId', ...rest
}: Props) => {
    const [field,, helpers] = useField(name);

    const handleChange = useCallback((groupId: string, subgroupId: string) => {
        helpers.setValue({[groupIdProp]: groupId, [subgroupIdProp]: subgroupId});
        onChange?.(groupId, subgroupId);
    }, [helpers, groupIdProp, subgroupIdProp, onChange]);

    return (
        <AssignmentSelectors
            {...rest}
            selectedGroupId={field.value?.[groupIdProp]}
            selectedSubgroupId={field.value?.[subgroupIdProp]}
            onChange={handleChange}
        />
    );
};
